"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetailsWrapper = exports.ProductDetails = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
class ProductDetails extends base_models_1.Serializable {
}
exports.ProductDetails = ProductDetails;
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({ example: '0000000000000000000000000000001000000020', description: 'product ID in SAP' }),
    tslib_1.__metadata("design:type", String)
], ProductDetails.prototype, "ProductID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({ example: 'MAT_ZEMP', description: 'category ID in SAP' }),
    tslib_1.__metadata("design:type", String)
], ProductDetails.prototype, "CategoryID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({ example: 'Non-commodity product', description: 'description in SAP' }),
    tslib_1.__metadata("design:type", String)
], ProductDetails.prototype, "Description", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({ example: '13.04.2023 15:04:23', description: 'product offer start date' }),
    tslib_1.__metadata("design:type", String)
], ProductDetails.prototype, "ValidFrom", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({ example: '31.12.9999 23:59:59', description: 'product offer end date' }),
    tslib_1.__metadata("design:type", String)
], ProductDetails.prototype, "ValidTo", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({ example: '', description: 'condition type, currently empty as it depends on pricing' }),
    tslib_1.__metadata("design:type", String)
], ProductDetails.prototype, "ConditionType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({ example: '', description: 'unit of measure, currently empty as it depends on pricing' }),
    tslib_1.__metadata("design:type", String)
], ProductDetails.prototype, "Uom", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({ example: '150.00', description: 'price' }),
    tslib_1.__metadata("design:type", String)
], ProductDetails.prototype, "Price", void 0);
class ProductDetailsWrapper extends base_models_1.Serializable {
}
exports.ProductDetailsWrapper = ProductDetailsWrapper;
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => ProductDetails),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({
        example: [
            ProductDetails.fromPlain({
                ProductID: '0000000000000000000000000000001000000020',
                CategoryID: 'MAT_ZEMP',
                Description: 'Non Commodity Product',
                ValidFrom: '13.04.2023 15:04:23',
                ValidTo: '31.12.9999 23:59:59',
                ConditionType: '',
                Uom: '',
                Price: '15.00',
            }),
        ],
        description: 'list of products',
    }),
    tslib_1.__metadata("design:type", Array)
], ProductDetailsWrapper.prototype, "results", void 0);
